import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { INDRADateService } from '@ibe.services/date.indra.service';

@Pipe({ name: 'printFormattedDate', pure: false })
export class INDRAPrintFormattedDate implements PipeTransform {

	constructor(private dateService: INDRADateService) { }

	transform(date: string | Date | moment.Moment, origFormat: string = 'DD/MM/YYYY'): string {
		return this.dateService.INDRA_getFormattedDate(date, origFormat);
	}
}
